import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-ios-redirect',
    template: `<p>Redirecting to App Store...</p>`
})
export class IosRedirectComponent implements OnInit {
    ngOnInit() {
        window.location.href = 'itms-apps://apps.apple.com/app/id1519473620';
    }
}
